/**
 * Build-time environment (Vite). Copy .env.example to .env and adjust per deploy target.
 */
const rawBase = import.meta.env.VITE_APP_BASE_NAME ?? "/";
export const APP_BASE_PATH =
  rawBase.endsWith("/") && rawBase !== "/" ? rawBase.slice(0, -1) : rawBase;

/**
 * Base URL of the Hostinger `server/` PHP API (reads MySQL only). No Zima Blade.
 * Example: https://pixolab.in/server  (no trailing slash)
 * Empty: use same-origin path `/server/...` (see Vite dev proxy in vite.config.mjs).
 */
export const DB_API_BASE_URL = (
  import.meta.env.VITE_APP_DB_API_BASE_URL ?? ""
).replace(/\/$/, "");

/** Google OAuth Web Client ID for GIS Sign-In button. */
export const GOOGLE_OAUTH_CLIENT_ID = import.meta.env.VITE_APP_GOOGLE_CLIENT_ID ?? "";
